import { render, staticRenderFns } from "./MediaLibraryPanel.vue?vue&type=template&id=56a0830e&scoped=true&"
import script from "./MediaLibraryPanel.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryPanel.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryPanel.vue?vue&type=style&index=0&id=56a0830e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0830e",
  null
  
)

export default component.exports